import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      asterisk: {
        color: tokens.fontColorError,
        paddingInlineStart: '4px',
      },
    },
  } as const
}
